import React, { Component } from 'react'
import ReactSelect from 'react-select'

export default class InvoiceProductForm extends Component {
  render() {
    const {
      brands, groups, categories, products, saleTypes,
      onCancel,
      selectedSaleType, selectedProduct,
      selectedBrand, selectedGroup, selectedCategory,
    } = this.props

    return (
      <form onSubmit={this.props.onSubmit} className="invoice-product-form">
        <div className="invoice-product-form-grid">
          <Field label="Tipo de instalação">
            <ReactSelect
              isClearable
              onChange={this.props.onSaleTypeChange}
              options={saleTypes}
              value={selectedSaleType}
              getOptionLabel={function(o) { return o.name }}
              getOptionValue={function(o) { return o.id }}
              placeholder="Selecione"
              className="w-full"
              classNamePrefix="invoice-select"
            />
          </Field>
          <Field label="Marca">
            <ReactSelect
              isClearable
              onChange={this.props.onBrandChange}
              options={brands}
              value={selectedBrand}
              getOptionLabel={function(o) { return o.name }}
              getOptionValue={function(o) { return o.id }}
              placeholder="Selecione"
              className="w-full"
              classNamePrefix="invoice-select"
            />
          </Field>
          <Field label="Grupo">
            <ReactSelect
              options={[]}
              placeholder="Selecione"
              className="w-full"
              classNamePrefix="invoice-select"
              isDisabled
            />
          </Field>
          <Field label="Categoria">
            <ReactSelect
              options={[]}
              placeholder="Selecione"
              className="w-full"
              classNamePrefix="invoice-select"
              isDisabled
            />
          </Field>
          <Field label="Código do produto">
            <ReactSelect
              isClearable
              onChange={this.props.onProductChange}
              options={products}
              value={selectedProduct}
              getOptionLabel={function(o) { return o.external_identifier }}
              getOptionValue={function(o) { return o.id }}
              placeholder="Selecione"
              className="w-full"
              classNamePrefix="invoice-select"
            />
          </Field>
          <Field label="Quantidade">
            <input
              type="number"
              name="quantity"
              min="1"
              defaultValue={1}
              placeholder="Inserir quantidade"
              className="invoice-form-input"
            />
          </Field>
        </div>

        <div className="invoice-product-form-footer">
          <button type="button" className="gl-button secondary medium body-m" onClick={onCancel}>
            Cancelar
          </button>
          <button type="submit" className="gl-button primary medium body-m">
            Adicionar
          </button>
        </div>
      </form>
    )
  }
}

const Field = function({ label, children }) {
  return (
    <div className="invoice-product-form-field">
      <label className="invoice-form-label">{label}</label>
      {children}
    </div>
  )
}
